// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nJ3K","name":"styles_name__1SAUT","phone":"styles_phone__1SH7-"};